/**
 * WordPress dependencies
 */
import { PanelBody } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';

import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
const { ColorControl, BackgroundControl, ResBoxControl, DynamicSwitcher, TypographyControl, ResRangeControl } =
    window.progressmatifyModules;

// obj attributes
import objAttributes from './attributes';

// constants
import { IMAX_WIDTH, GL_GAP, G_TYPO, N_TYPO, G_MARGIN, F_BG, B_BG, G_RADIUS, FG_RADIUS } from './constants';

const Inspector = props => {
    const { attributes, setAttributes } = props;
    const {
        // style

        numberColor,
        textColor
    } = attributes;

    const objAttrs = { attributes, setAttributes, objAttributes };

    return (
        <InspectorControls key="inspector">
            <PanelBody title={__('Layout', 'progressmatify-blocks')} initialOpen={false}>
                <ResRangeControl label={__('Gap', 'progressmatify-blocks')} controlName={GL_GAP} objAttrs={objAttrs} min={1} max={100} />
                <ResRangeControl
                    label={__('Max Width', 'progressmatify-blocks')}
                    controlName={IMAX_WIDTH}
                    objAttrs={objAttrs}
                    min={1}
                    max={2000}
                />

                <ResBoxControl label={__('Margin', 'progressmatify-blocks')} controlName={G_MARGIN} objAttrs={objAttrs} />
            </PanelBody>
            <PanelBody title={__('Background', 'progressmatify-blocks')} initialOpen={false}>
                <DynamicSwitcher
                    options={[
                        {
                            label: __('Backgroun-color', 'progressmatify-blocks'),
                            value: 'Background'
                        },
                        {
                            label: __('Border Radius', 'progressmatify-blocks'),
                            value: 'Radius'
                        }
                    ]}
                    contentMap={{
                        Background: (
                            <>
                                <BackgroundControl
                                    label={__('Background ', 'progressmatify-blocks')}
                                    controlName={B_BG}
                                    objAttrs={objAttrs}
                                />
                                <BackgroundControl
                                    label={__('F-Background', 'progressmatify-blocks')}
                                    controlName={F_BG}
                                    objAttrs={objAttrs}
                                />
                            </>
                        ),
                        Radius: (
                            <>
                                <ResBoxControl label={__('B-RADIUS', 'progressmatify-blocks')} controlName={G_RADIUS} objAttrs={objAttrs} />
                                <ResBoxControl
                                    label={__('F-RADIUS', 'progressmatify-blocks')}
                                    controlName={FG_RADIUS}
                                    objAttrs={objAttrs}
                                />
                            </>
                        )
                    }}
                />
            </PanelBody>
            <PanelBody title={__('Text', 'progressmatify-blocks')} initialOpen={false}>
                <ColorControl
                    label={__('Text Color', 'progressmatify-blocks')}
                    color={textColor}
                    onChange={v => {
                        setAttributes({ textColor: v });
                    }}
                />

                <TypographyControl label={__('Typography', 'progressmatify-blocks')} objAttrs={objAttrs} controlName={G_TYPO} />
            </PanelBody>
            <PanelBody title={__('Number', 'progressmatify-blocks')} initialOpen={false}>
                <ColorControl
                    label={__('Number Color', 'progressmatify-blocks')}
                    color={numberColor}
                    onChange={v => {
                        setAttributes({ numberColor: v });
                    }}
                />

                <TypographyControl label={__('Typography', 'progressmatify-blocks')} objAttrs={objAttrs} controlName={N_TYPO} />
            </PanelBody>
        </InspectorControls>
    );
};

export default Inspector;
